module.exports = __webpack_public_path__ + "static/img/design-2.9890f5dc.png";